import { getEnv } from "@ace/env";
import { sessionStorageKeys } from "../constants";

export interface FundOrder {
  id: string;
  investmentId: number;
  organisationId: number;
  userId: number;
  type: string;
  traceId: string;
  status: string;
  reason: string;
  initialAmount: string;
  initialPricePerUnit: number;
  initialQuantity: string;
  finalPriceRequestId: string | null;
  finalAmount: string | null;
  finalQuantity: string | null;
  finalPricePerUnit: number | null;
  sourceAccountId: number;
  targetAccountId: number;
  created: string;
  updated: string;
}

export const getFundOrders = async (): Promise<FundOrder[]> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${sessionStorage.getItem(sessionStorageKeys.token)}`,
  };
  const response = await fetch(
    `${getEnv("VITE_ACE_WEB_AUTH_SERVER")}/rest-gateway/invest/order`,
    {
      method: "GET",
      headers,
    },
  );
  const json = await response.json();

  if (json.status === "ERROR") {
    throw new Error(json.error[0].msg.error[0].msg);
  }

  const data = json.data as FundOrder[];

  return data;
};
